var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "txt-pin", class: _vm.mixClasses }, [
    _c("div", { staticClass: "pin-placeholder" }, [
      _c("div", { class: _vm.pinClass }, [
        _c("i", {
          staticClass: "fa fa-thumb-tack",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.text))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }